import PrincipleCard from "./principleHelper";
import "./principleMain.css";

const PrincipleMain = () => {
  const principles = [
    {
      number: "01",
      title: "Ideation",
      description: "Translating abstract challenges into structured, scalable solutions has been central to my approach across tech and design.",
      width: "58%",
      height: "300px"
    },
    {
      number: "02",
      title: "Curiosity",
      description: "A natural drive to explore how and why keeps me evolving. I stay in motion.",
      width: "39%",
      height: "300px"
    },
    {
      number: "03",
      title: "Dedication",
      description: "Every project I take on reflects a mindset rooted in consistency, accountability, and long-term growth.",
      width: "39%",
      height: "300px"
    },
    {
      number: "04",
      title: "Innovation",
      description: "I actively explore emerging technologies to craft efficient systems that go beyond convention and deliver real impact.",
      width: "58%",
      height: "300px"
    },
    {
      number: "05",
      title: "AND MANY MORE....",
      description: "PRACTICALITY | RESILIENCE | AUTHENTICITY | CONTINUOUS LEARNING | ADAPTABILITY | SYSTEMATIC THINKING | TECHNICAL EXCELLENCE | SELF-DISCIPLINE | PURPOSE-DRIVEN EXECUTION",
      width: "98.7%",
      height: "250px"
    }
  ];

  return (
    <div>
      <div className="PrincipleMain-Component">
        <p className="titlePrinciple">Principles</p>
        <div className="principles-grid">
          {principles.map((item, index) => (
            <PrincipleCard
              key={index}
              number={item.number}
              title={item.title}
              description={item.description}
              width={item.width}
              height={item.height}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrincipleMain;